import { render, staticRenderFns } from "./PrivacyRadioGroup.vue?vue&type=template&id=4a0fe508"
import script from "./PrivacyRadioGroup.vue?vue&type=script&lang=ts"
export * from "./PrivacyRadioGroup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports